var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    transform: "translate(-886.000000, -9981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(886.000000, 9981.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-5",
    fill: "#FFEAEC",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-pc-47LX6EYFBT",
    transform: "translate(18.000000, 20.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,40.6111111 C7.33333333,39.2917278 8.42776,38.2222222 9.77777778,38.2222222 L34.2222222,38.2222222 C35.5722889,38.2222222 36.6666667,39.2917278 36.6666667,40.6111111 C36.6666667,41.9304944 35.5722889,43 34.2222222,43 L9.77777778,43 C8.42776,43 7.33333333,41.9304944 7.33333333,40.6111111 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.16666667 C0,3.20863611 3.28325556,0 7.33333333,0 L36.6666667,0 C40.7168667,0 44,3.20863611 44,7.16666667 L44,26.2777778 C44,30.2359278 40.7168667,33.4444444 36.6666667,33.4444444 L7.33333333,33.4444444 C3.28325556,33.4444444 0,30.2359278 0,26.2777778 L0,7.16666667 Z M7.33333333,4.77777778 C5.98331556,4.77777778 4.88888889,5.84733111 4.88888889,7.16666667 L4.88888889,26.2777778 C4.88888889,27.5971611 5.98331556,28.6666667 7.33333333,28.6666667 L36.6666667,28.6666667 C38.0167333,28.6666667 39.1111111,27.5971611 39.1111111,26.2777778 L39.1111111,7.16666667 C39.1111111,5.84733111 38.0167333,4.77777778 36.6666667,4.77777778 L7.33333333,4.77777778 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "19.5555556 40.6111111 19.5555556 31.0555556 24.4444444 31.0555556 24.4444444 40.6111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7777778,9.55555556 C33.1278444,9.55555556 34.2222222,10.6251089 34.2222222,11.9444444 L34.2222222,21.5 C34.2222222,22.8193833 33.1278444,23.8888889 31.7777778,23.8888889 C30.4277111,23.8888889 29.3333333,22.8193833 29.3333333,21.5 L29.3333333,11.9444444 C29.3333333,10.6251089 30.4277111,9.55555556 31.7777778,9.55555556 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,14.3333333 C23.3500667,14.3333333 24.4444444,15.4028867 24.4444444,16.7222222 L24.4444444,21.5 C24.4444444,22.8193833 23.3500667,23.8888889 22,23.8888889 C20.6499333,23.8888889 19.5555556,22.8193833 19.5555556,21.5 L19.5555556,16.7222222 C19.5555556,15.4028867 20.6499333,14.3333333 22,14.3333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2222222,16.7222222 C13.57224,16.7222222 14.6666667,17.7917278 14.6666667,19.1111111 L14.6666667,21.5 C14.6666667,22.8193833 13.57224,23.8888889 12.2222222,23.8888889 C10.8722044,23.8888889 9.77777778,22.8193833 9.77777778,21.5 L9.77777778,19.1111111 C9.77777778,17.7917278 10.8722044,16.7222222 12.2222222,16.7222222 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictiveIcon);
export default __webpack_public_path__ + "static/media/predictive-icon.f60a380acb2d363f8fb723ce1fcd9e0d.svg";
export { ForwardRef as ReactComponent };